<template>
  <modal
    :title="$t(title)"
    :appendToBody="true"
    :top="'12vh'"
    :visible.sync="isShowDialog"
  >
    <div class="configNetPage">
      <!-- 基本信息 -->
      <ul class="base-info">
        <li v-for="item in baseMsg" :key="item.key">
          <span class="label">{{ $t(item.text) }}：</span>
          <span class="value">
            <template v-if="item.key === 'type' || item.key === 'configStatus'">
              <span>{{ changeTextFn(item.key, cmdObj[item.key]) }}</span>
            </template>
            <template v-else-if="item.key === 'step'">
              <span>{{ stepFn(cmdObj[item.key]) }}</span>
            </template>
            <template v-else-if="item.isBool">
              <span v-if="cmdObj['configStatus'] !== 2">{{
                objFn1(cmdObj[item.key])
              }}</span>
              <span style="color:red">{{ objFn2(cmdObj[item.key]) }}</span>
            </template>
            <span v-else>
              {{ cmdObj[item.key] }}
            </span>
          </span>
        </li>
      </ul>
    </div>
  </modal>
</template>

<script>
import { configStep } from '@/utils/convert'

export default {
  props: {
    title: {},
    isShow: {},
    cmdObj: {}
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  watch: {
    cmdObj (newVal) {
      let publicbaseMsg = [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'device.display_name',
          key: 'name'
        },
        {
          text: 'device.display_number',
          key: 'display_code'
        },

        {
          text: 'public.config_status',
          key: 'configStatus'
        },
        {
          text: 'public.carrier',
          key: 'carrierName'
        },
        {
          text: 'device.display_type',
          key: 'type'
        }
      ]

      const appArray = [
        {
          text: $t('integration.alarm_or_not'),
          key: 'alarmOn',
          isBool: true
        },
        {
          text: $t('integration.duration_(seconds)'),
          key: 'alarmPeriod',
          isBool: true
        },
        {
          text: $t('integration.time_interval_(seconds)'),
          key: 'alarmInterval',
          isBool: true
        },
        {
          text: 'public.command',
          key: 'cmd'
        },
        {
          text: $t('integration.configuration_steps'),
          key: 'step'
        }
      ]
      const netArray = [
        {
          text: 'ext Pan Id',
          key: 'extPanId',
          isBool: true
        },
        {
          text: 'Join Attemp',
          key: 'channelPage',
          isBool: true
        },
        {
          text: 'device.transmit_power',
          key: 'transmitPower',
          isBool: true
        },
        {
          text: 'device.channel_mask',
          key: 'channelMask',
          isBool: true
        },
        {
          text: 'device.in_net_interval',
          key: 'inNetInterval',
          isBool: true
        },
        {
          text: 'public.command',
          key: 'cmd'
        },
        {
          text: $t('integration.configuration_steps'),
          key: 'step'
        }
      ]
      if (this.$attrs.sensorWay === 'unbind') {
        publicbaseMsg = publicbaseMsg.filter(item => item.key !== 'carrierName')
      }
      if (newVal.typeWay === 'app') {
        this.baseMsg = [...publicbaseMsg, ...appArray]
      } else {
        this.baseMsg = [...publicbaseMsg, ...netArray]
      }
    }
  },
  data () {
    return {
      baseMsg: []
    }
  },
  methods: {
    changeTextFn (key, value) {
      if (key === 'type') {
        return value === 1 ? $t('deviceType.dt_1') : $t('public.display')
      } else if (key === 'step') {
        return value === 1
          ? $t('device.wait_config')
          : value === 1
            ? $t('device.configured')
            : $t('device.configured')
      } else {
        return value === 0
          ? $t('device.wait_config')
          : value === 1
            ? $t('device.configured')
            : $t('device.configured')
      }
    },
    objFn1 (obj) {
      return obj ? obj.current + '-->' : ''
    },
    objFn2 (obj) {
      return obj ? obj.modify : ''
    },
    stepFn (value) {
      return configStep[value] && this.$t(configStep[value].title)
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;
    padding: 10px 20px;
    max-height: 600px;
    overflow: auto;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 32px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 32px;
      text-align: left;
      color: #606266;
      font-size: 14px;
    }
  }
}
</style>
